/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

//      $(window).scroll(function() {
//        var circle = $('.tech-circle');
//             circle.removeClass('is-visible');
//        if (circle:in-viewport().hasClass('is-visible')){
//        console.log(1);
//        }
//        else {
//             $('.tech-circle:in-viewport()').addClass('is-visible');
//        }
//         });

// $(window).scroll(function () {
//     if ($('.tech-circle').isInViewport()) {
//         //  Use .blogcard instead of this
//         $('.tech-circle').addClass('test');
//         console.log('success.')
//     } else {
//         //  Remove class
//         $('.tech-circle').removeClass('test');
//         console.log('No success.')
//     }
// });

/*!
 * Determine if an element is in the viewport
 * (c) 2017 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}    elem The element
 * @return {Boolean}      Returns true if element is in the viewport
 */

var isInViewport = function isInViewport(element, offset) {
  if (typeof jQuery === "function" && element instanceof jQuery) {
    element = element.get(0);
  }
  if (typeof offset === "undefined") {
    offset = 0;
  }
  var bounds = element.getBoundingClientRect();
  return bounds.top + offset < window.innerHeight && bounds.bottom - offset > 0;
};

// (function($) {
//     $(document).ready(function() {
//         $('.tech-circle').removeClass('is-visible')
//         $('.tech-circle:in-viewport').addClass('is-visible');
//         $(window).scroll(function() {
//            $('.tech-circle').removeClass('is-visible')
//        		 $('.tech-circle:in-viewport').addClass('is-visible');
//         });
//     });
// }(jQuery));

// function drawLinearts() {

//             var $lineart = $('.tech-circle');
//             if (isInViewport($lineart)) {
//                 $lineart.addClass('isVisible');
//             } else {
//                 $lineart.removeClass('isVisible');
//             }
//  }

var namespace = ".tech";
var lineart = "[data-tech-lineart]";

$linearts = $(lineart, namespace);

function drawLinearts() {
  for (var i = 0; i < $linearts.length; i++) {
    var $lineart = $($linearts[i]);
    if (isInViewport($lineart)) {
      $lineart.addClass("is-visible");
    } else {
      $lineart.removeClass("is-visible");
    }
  }
}

$(window).scroll(function () {
  drawLinearts();
});
$(".circled").each(function () {
  $(
    this
  ).append(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 482.9 168.3">
              <path fill="none" stroke="#000000" stroke-width="12" stroke-miterlimit="10" stroke-linecap="round" d="M353.3,5.7C378,14.4,494.8,21.1,474.5,76
                c-20.3,54.9-193.7,87.6-277.7,86.3c-52.1-0.8-105.7-9.4-150.6-40.4C26.4,108.3,7.4,87.4,6,60.5c4.6-42.9,157.6-50.4,225.7-48.4
                c63.1,1.8,150.3,4.6,211.4,23.3"></path>
            </svg>`);
});

$(".invertible-slider-outer").slick({
  arrows: true,
  dots: true,
  infinite: false,
  autoplay: false,
  appendDots: $(".dots-invertible"),
  prevArrow: $(".prev-invertible"),
  nextArrow: $(".next-invertible"),
  asNavFor: ".invertible-slider-numbers,.flex-container__inner-img",
});
$(".flex-container__inner-img").slick({
  arrows: false,
  dots: false,
  infinite: false,
  autoplay: false,
  fade: true,
  asNavFor: ".invertible-slider-outer,.invertible-slider-numbers",
});
$(".invertible-slider-numbers").slick({
  arrows: false,
  dots: false,
  infinite: false,
  autoplay: false,
  fade: true,
  asNavFor: ".invertible-slider-outer,.flex-container__inner-img",
});

$(".product-description-wrapper  .accordion .accordion-thumb").click(
  function () {
    //$(".container--{{ section.id }} .accordion-item").removeClass("is-active").find(".accordion-panel").slideUp();
    $(this)
      .toggleClass("is-active-thumb")
      .closest(".accordion-item")
      .toggleClass("is-active")
      .find(".accordion-panel")
      .slideToggle();
    $(this).find(".icon").toggleClass("rotate--icons");
  }
);
$(".payment-button").click(function () {
  $("[data-add-to-cart]").click();
});

setInterval(function time() {
  var d = new Date();
  var d1 = new Date();
  d.setHours(d1.getHours() + 9);
  var hours = 23 - d.getHours();
  var min = 59 - d.getMinutes();
  if ((min + "").length == 1) {
    min = "0" + min;
  }
  var sec = 59 - d.getSeconds();
  if ((sec + "").length == 1) {
    sec = "0" + sec;
  }
  $(".timer").html(hours + ":" + min + ":" + sec + "s");

  var currentDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
  var currentDateNew = new Date(new Date().getTime() + 120 * 60 * 60 * 1000);
  var day = currentDateNew.getDate();
  let dayN = "th";
  switch (day) {
    case 1:
      dayN = "st";
      break;
    case 2:
      dayN = "nd";
      break;
    case 3:
      dayN = "rd";
      break;
    default:
      dayN = "th";
  }
  var month = currentDate.getMonth() + 1;
  var year = currentDate.getFullYear();
  var days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  $(".date-product").html(
    days[currentDateNew.getDay()] +
      ", " +
      day +
      dayN +
      " " +
      monthNames[currentDateNew.getMonth()]
  );
}, 1000);

$(".eam-custom-cart-overlay").click(function () {
  $(".size-guide-popup").fadeOut();
  $("body").removeClass("eam-no-scroll");
});
$(".size-guide-close").click(function () {
  $(".eam-custom-cart-overlay").fadeOut();
  $(".size-guide-popup").fadeOut();
  $("body").removeClass("eam-no-scroll");
});
$(".size-chart-trigger").click(function () {
  $(".eam-custom-cart-overlay").fadeIn();
  $(".size-guide-popup").fadeIn();
  $("body").addClass("eam-no-scroll");
});

$(".read-more-product").click(function () {
  $(".short-description-product").slideUp();
  $(".full-description-product").slideDown();
});

// Split Details Using JS
// Method 1
// $(document).ready(function(){
//   if($('.full-description-product').text().includes('Details:')){
//     var details_data='<ul'+$('.full-description-product').html().split('Details:')[1].split('</ul>')[0].split('<ul')[1];
//   }else if($('.full-description-product').text().includes('Features:')){
//     var details_data='<ul'+$('.full-description-product').html().split('Features:')[1].split('</ul>')[0].split('<ul')[1];
//   }else if($('.full-description-product').text().includes('details:')){
//     var details_data='<ul'+$('.full-description-product').html().split('details:')[1].split('</ul>')[0].split('<ul')[1];
//   }else if($('.full-description-product').text().includes('features:')){
//     var details_data='<ul'+$('.full-description-product').html().split('features:')[1].split('</ul>')[0].split('<ul')[1];
//   }else if($('.full-description-product').text().includes('DETAILS:')){
//     var details_data='<ul'+$('.full-description-product').html().split('DETAILS:')[1].split('</ul>')[0].split('<ul')[1];
//   }else if($('.full-description-product').text().includes('FEATURES:')){
//     var details_data='<ul'+$('.full-description-product').html().split('FEATURES:')[1].split('</ul>')[0].split('<ul')[1];
//   }
//   debugger
//   if($('.full-description-product ul').length>0 && ( $('.full-description-product').text().toLowerCase().includes('features:') || $('.full-description-product').text().toLowerCase().includes('details:'))){
//     $($('.product-description')[1]).find('.accordion-panel ul').html(details_data);

//     // $('.full-description-product ul').remove();
//     // $('.full-description-product').text($('.full-description-product').text().replaceAll('Details:',''))
//   }else{
//     $($('.product-description')[1]).hide();
//   }
// })

// Method 2
// $(document).ready(function(){
//   if($('.full-description-product ul').length>0 && ( $('.full-description-product').text().toLowerCase().includes('features:') || $('.full-description-product').text().toLowerCase().includes('details:'))){
//     $($('.product-description')[1]).find('.accordion-panel ul').empty();
//     let navbar = document.querySelectorAll('.full-description-product ul');
//     for(j=0;j<navbar.length;j++){
//       if(template_name == 'product.game-tech'){
//         $($('.product-description')[2]).find('.accordion-panel ul').append(navbar[j].innerHTML);
        
//       }else{
//         $($('.product-description')[1]).find('.accordion-panel ul').append(navbar[j].innerHTML);
        
//       }
//     }

//   }else{
//     $($('.product-description')[1]).hide();
//   }
// })




// Revision 
$(window).on("load", function () {
  if($($('.accordion-custom-section .product-description .accordion-item .accordion-thumb')[0])){
     $($('.accordion-custom-section .product-description .accordion-item .accordion-thumb')[0]).trigger('click');
  }
  if($('.checkmarks--container')){
    $('.checkmarks--container').prev().hide()
  }
});

$(document).ready(function(){
  function initReviewSlider(){
    if($('.custom-review-slider-box-container').length){
      $('.custom-review-slider-box-container').flickity({
        cellAlign: 'center',
        groupCells: 1,
        pageDots: true,
        wrapAround: true,
        prevNextButtons: false,
        watchCSS: true,
        freeScroll: true,
        imagesLoaded: true
      });
    }
  }
  initReviewSlider();

  const testimonialSlider = $(".testimonial-slider-wrapper");
  if(testimonialSlider.length){
    testimonialSlider.flickity({
        cellAlign: 'center',
        groupCells: 1,
        pageDots: true,
        wrapAround: true,
        prevNextButtons: false,
        freeScroll: false,
        imagesLoaded: true
    });
  }

  const shopProv4 = $(".shop-pro-v4");
  if(shopProv4.length){
    shopProv4.each(function(){
      const $this = $(this);
      $this.flickity({
        cellAlign: 'left',
        contain: true,
        groupCells: 1,
        pageDots: false,
        wrapAround: false,
        prevNextButtons: false,
        draggable: true,
        watchCSS: true,
        freeScroll: true,
        imagesLoaded: true,
        on: {
          scroll: function (progress) {
              const newProgress = progress + 0.25;
              progress = Math.max( 0, Math.min( 1, newProgress ) );
              const progressBar = $this.siblings('.shop-pro-progress-bar').find('.shop-pro-progress-bar-inner')[0];
              progressBar.style.width = progress * 100 + '%';            
          },
        },
    });
    });
    
  }
    
})

var $jq = jQuery.noConflict();
$jq(document).ready(function() { 
  if(window.outerWidth < 786){
    $jq('.custom-review-slider-box-container-v2').slick({
      dots: true
    });
  }
});


